import type { RoundResult } from "./game/types";

export type LeaderboardEntry = RoundResult & {
  id: number;
  name: string;
  createdAt: string;
};

export async function loadLeaderboard(themeId: string, limit = 20): Promise<LeaderboardEntry[]> {
  const params = new URLSearchParams({
    themeId,
    limit: String(limit)
  });
  const response = await fetch(`/api/leaderboard?${params}`);

  if (!response.ok) {
    throw new Error("leaderboard_load_failed");
  }

  const payload = (await response.json()) as { entries: LeaderboardEntry[] };
  return payload.entries;
}

export async function submitScore(name: string, result: RoundResult): Promise<LeaderboardEntry> {
  const response = await fetch("/api/leaderboard", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      ...result,
      name
    })
  });

  if (!response.ok) {
    throw new Error("score_submit_failed");
  }

  const payload = (await response.json()) as { entry: LeaderboardEntry };
  return payload.entry;
}
